import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { SharedModule } from '@app/shared/shared.module';
import { EnergieMonitorComponent } from './energiemonitor.component';
import { EnergieMonitorLegacyComponent } from './_legacy/components/_energiemonitor.component';

@NgModule({
  imports: [CommonModule, SharedModule],
  declarations: [EnergieMonitorComponent, EnergieMonitorLegacyComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class EnergieMonitorModule {}
